var isBrowser = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
export default isBrowser;
//# sourceMappingURL=isBrowser.js.map